import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitButton'];

  changeConsent(event) {
    console.log('loahsdf', event.target.checked)
    console.log(this.submitButtonTarget)

    this.submitButtonTarget.disabled = !event.target.checked;
  }
}
